module.exports = "images/enfants_8.2810964c.png";